module.exports = __webpack_public_path__ + "88f87b6651b6fdc8a3bdcd9169a45ef4.svg";